export const couponStatusKeys = {
  none: "None",
  invalid: "Invalid",
  valid: "Valid",
};

export const couponAvailabilityKeys = {
    available: "Available",
    notAvailable: "Not Available"
}
